module.exports = __webpack_public_path__ + "static/media/big-banner.cb58e513.jpg";